import { isFinanceProject, isGlobalProject } from 'config';

export const getClientRiskLevelFormSectionKeys = (): string[] => {
  if (isGlobalProject()) {
    return ['riskLevel', 'kyc', 'pepConnection', 'sourcesOfIncome'];
  }

  if (isFinanceProject()) {
    return ['riskLevel', 'kyc', 'pepConnection'];
  }

  return [];
};
